import React from "react";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, FormControlLabel } from "@mui/material";
import { useAppState } from "../../states/app-state";
import { Observer, observer } from "mobx-react-lite";
import DisabledClickLoading from "../../components/DisabledClickLoading";
// useStyles removed by Bearer Web Developer


const VersionAgreement: React.FC = observer(() => {

    const appState = useAppState();
    const open = appState.profile.agreementNeeded;

    const [loading, setLoading] = React.useState(false);
    const handleAgree = () => {
        try {
            setLoading(true);
            appState.profile.handleUpdateAgreedVersion();
        } catch (err) {
            setLoading(false);
        }
    };
    React.useEffect(() => {
        appState.getWebAppRemoteConfigParameters();
    }, [appState, open]);

    const [checked, setChecked] = React.useState(true);
    const handleChange = (event: any) => {
        setChecked(event.target.checked);
    };
    return (

        <Dialog PaperProps={{ style: { borderRadius: "10px" } }}
            className={''}
            open={open}
            maxWidth="sm"
        >
            <DialogContent>
                <DialogContentText>
                    We updated our Terms & Conditions and Privacy Policy :
                </DialogContentText>
                <FormControlLabel
                    className={''}
                    control={<Checkbox color="primary" checked={checked} onChange={handleChange} />}
                    label={
                        <>
                            I agree to the <a href={appState.webAppRemoteConfigParameters?.legal} target="_blank" rel="noreferrer">Terms & Conditions </a>and <a href={appState.webAppRemoteConfigParameters?.privacyPolicy} target="_blank" rel="noreferrer">Privacy Policy</a>.
                        </>
                    }
                />
            </DialogContent>
            <DialogActions >
                <Observer>{() => {
                    const valid = !checked;
                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAgree}
                            disabled={valid}
                            className={''}
                        >
                            Confirm
                        </Button>
                    )
                }}</Observer>
                {loading && <DisabledClickLoading />}
            </DialogActions>
        </Dialog>

    );
})
export default VersionAgreement;
